import {
  List,
  Datagrid,
  TextField,
  DateField,
  ShowButton,
  TextInput,
  ReferenceInput,
  SelectInput,
  FunctionField,
  usePermissions,
} from 'react-admin';
import { ChipList, ListActions } from '../common';
import { Machine, Group } from '../../types';
import { useFetchAssociation } from '../../utils/hooks';

const GroupsField = ({ record }: { record?: Machine }) => {
  const { data: groups, loading } = useFetchAssociation<Group>({
    resourceId: record?.id,
    endpoint: `/api/machines/${record?.id}/groups`,
  });

  return (
    <ChipList
      emptyText="No Groups"
      items={groups.map((g) => ({ id: g.id, label: g.name, to: `/groups/${g.id}/show` }))}
      loading={loading}
    />
  );
};

const MachineFilters = (isAdmin: boolean) => {
  const filters = [<TextInput key="serial" label="Serial" source="q" alwaysOn />];

  if (isAdmin) {
    filters.push(
      <ReferenceInput key="groupId" label="Group" source="groupId" reference="groups" alwaysOn>
        <SelectInput optionText="name" />
      </ReferenceInput>
    );
  }

  return filters;
};

export const MachineList = () => {
  const { permissions } = usePermissions();
  const isAdmin = permissions === 'Admin';

  return (
    <List
      filters={MachineFilters(isAdmin)}
      actions={<ListActions hasCreate={false} />}
      sort={{ field: 'id', order: 'DESC' }}
    >
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="id" />
        <TextField source="serial" />
        {isAdmin && (
          <FunctionField
            label="Groups"
            render={(record: Machine) => <GroupsField record={record} />}
            sortable={false}
          />
        )}
        <DateField source="lastStarted" showTime />
        <DateField source="lastPrinting" showTime />
        <ShowButton />
      </Datagrid>
    </List>
  );
};
